import { t as e } from "./utils-DiFe-_ei.js";
import { a as t, i as n } from "./dist-7tgynhKG.js";
import { l as r } from "./es2015-Dfq2CQHn.js";
import { a as i, o as a, r as o, t as s } from "./dist-BWsUe_id.js";
import { t as c } from "./search-Chd7o8f1.js";
import * as l from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import "react-dom";
//#region ../../node_modules/.pnpm/cmdk@1.1.1_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react@19.2.17_react-dom_bc1678d6d5a7ffb92aa41dc7846a5030/node_modules/cmdk/dist/chunk-NZJY6EH4.mjs
var f = 1, p = .9, m = .8, h = .17, g = .1, _ = .999, v = .9999, y = .99, b = /[\\\/_+.#"@\[\(\{&]/, ee = /[\\\/_+.#"@\[\(\{&]/g, x = /[\s-]/, S = /[\s-]/g;
function C(e, t, n, r, i, a, o) {
	if (a === t.length) return i === e.length ? f : y;
	var s = `${i},${a}`;
	if (o[s] !== void 0) return o[s];
	for (var c = r.charAt(a), l = n.indexOf(c, i), u = 0, d, w, T, E; l >= 0;) d = C(e, t, n, r, l + 1, a + 1, o), d > u && (l === i ? d *= f : b.test(e.charAt(l - 1)) ? (d *= m, T = e.slice(i, l - 1).match(ee), T && i > 0 && (d *= _ ** +T.length)) : x.test(e.charAt(l - 1)) ? (d *= p, E = e.slice(i, l - 1).match(S), E && i > 0 && (d *= _ ** +E.length)) : (d *= h, i > 0 && (d *= _ ** +(l - i))), e.charAt(l) !== t.charAt(a) && (d *= v)), (d < g && n.charAt(l - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(l - 1) !== r.charAt(a)) && (w = C(e, t, n, r, l + 1, a + 2, o), w * g > d && (d = w * g)), d > u && (u = d), l = n.indexOf(c, l + 1);
	return o[s] = u, u;
}
function w(e) {
	return e.toLowerCase().replace(S, " ");
}
function T(e, t, n) {
	return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, C(e, t, w(e), w(t), 0, 0, {});
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.2.5_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-slot/dist/index.mjs
// @__NO_SIDE_EFFECTS__
function E(e) {
	let n = l.forwardRef((n, r) => {
		let { children: i, ...a } = n, o = null, s = !1, c = [];
		N(i) && typeof L == "function" && (i = L(i._payload)), l.Children.forEach(i, (e) => {
			if (j(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				N(n) && typeof L == "function" && (n = L(n._payload)), o = O(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = l.cloneElement(o, void 0, c) : !s && l.Children.count(i) === 1 && l.isValidElement(i) && (o = i);
		let u = o ? A(o) : void 0, d = t(r, u);
		if (!o) {
			if (i || i === 0) throw Error(s ? I(e) : F(e));
			return i;
		}
		let f = k(a, o.props ?? {});
		return o.type !== l.Fragment && (f.ref = r ? d : u), l.cloneElement(o, f);
	});
	return n.displayName = `${e}.Slot`, n;
}
var D = Symbol.for("radix.slottable"), O = (e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return l.isValidElement(t) ? l.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return l.isValidElement(t) ? t : null;
};
function k(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
function A(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function j(e) {
	return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === D;
}
var M = Symbol.for("react.lazy");
function N(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === M && "_payload" in e && P(e._payload);
}
function P(e) {
	return typeof e == "object" && !!e && "then" in e;
}
var F = (e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, I = (e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, L = l.use, R = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ E(`Primitive.${t}`), r = l.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {}), z = "[cmdk-group=\"\"]", B = "[cmdk-group-items=\"\"]", te = "[cmdk-group-heading=\"\"]", ne = "[cmdk-item=\"\"]", V = `${ne}:not([aria-disabled="true"])`, H = "cmdk-item-select", U = "data-value", re = (e, t, n) => T(e, t, n), ie = l.createContext(void 0), W = () => l.useContext(ie), ae = l.createContext(void 0), G = () => l.useContext(ae), K = l.createContext(void 0), q = l.forwardRef((e, t) => {
	let n = X(() => ({
		search: "",
		value: e.value ?? e.defaultValue ?? "",
		selectedItemId: void 0,
		filtered: {
			count: 0,
			items: /* @__PURE__ */ new Map(),
			groups: /* @__PURE__ */ new Set()
		}
	})), i = X(() => /* @__PURE__ */ new Set()), a = X(() => /* @__PURE__ */ new Map()), o = X(() => /* @__PURE__ */ new Map()), s = X(() => /* @__PURE__ */ new Set()), c = ge(e), { label: u, children: d, value: f, onValueChange: p, filter: m, shouldFilter: h, loop: g, disablePointerSelection: _ = !1, vimBindings: v = !0, ...y } = e, b = r(), ee = r(), x = r(), S = l.useRef(null), C = ve();
	Y(() => {
		if (f !== void 0) {
			let e = f.trim();
			n.current.value = e, w.emit();
		}
	}, [f]), Y(() => {
		C(6, A);
	}, []);
	let w = l.useMemo(() => ({
		subscribe: (e) => (s.current.add(e), () => s.current.delete(e)),
		snapshot: () => n.current,
		setState: (e, t, r) => {
			var i, a, o;
			if (!Object.is(n.current[e], t)) {
				if (n.current[e] = t, e === "search") k(), D(), C(1, O);
				else if (e === "value") {
					if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
						let e = document.getElementById(x);
						e ? e.focus() : (i = document.getElementById(b)) == null || i.focus();
					}
					if (C(7, () => {
						n.current.selectedItemId = j()?.id, w.emit();
					}), r || C(5, A), c.current?.value !== void 0) {
						let e = t ?? "";
						(o = (a = c.current).onValueChange) == null || o.call(a, e);
						return;
					}
				}
				w.emit();
			}
		},
		emit: () => {
			s.current.forEach((e) => e());
		}
	}), []), T = l.useMemo(() => ({
		value: (e, t, r) => {
			t !== o.current.get(e)?.value && (o.current.set(e, {
				value: t,
				keywords: r
			}), n.current.filtered.items.set(e, E(t, r)), C(2, () => {
				D(), w.emit();
			}));
		},
		item: (e, t) => (i.current.add(e), t && (a.current.has(t) ? a.current.get(t).add(e) : a.current.set(t, /* @__PURE__ */ new Set([e]))), C(3, () => {
			k(), D(), n.current.value || O(), w.emit();
		}), () => {
			o.current.delete(e), i.current.delete(e), n.current.filtered.items.delete(e);
			let t = j();
			C(4, () => {
				k(), t?.getAttribute("id") === e && O(), w.emit();
			});
		}),
		group: (e) => (a.current.has(e) || a.current.set(e, /* @__PURE__ */ new Set()), () => {
			o.current.delete(e), a.current.delete(e);
		}),
		filter: () => c.current.shouldFilter,
		label: u || e["aria-label"],
		getDisablePointerSelection: () => c.current.disablePointerSelection,
		listId: b,
		inputId: x,
		labelId: ee,
		listInnerRef: S
	}), []);
	function E(e, t) {
		let r = c.current?.filter ?? re;
		return e ? r(e, n.current.search, t) : 0;
	}
	function D() {
		if (!n.current.search || c.current.shouldFilter === !1) return;
		let e = n.current.filtered.items, t = [];
		n.current.filtered.groups.forEach((n) => {
			let r = a.current.get(n), i = 0;
			r.forEach((t) => {
				let n = e.get(t);
				i = Math.max(n, i);
			}), t.push([n, i]);
		});
		let r = S.current;
		M().sort((t, n) => {
			let r = t.getAttribute("id"), i = n.getAttribute("id");
			return (e.get(i) ?? 0) - (e.get(r) ?? 0);
		}).forEach((e) => {
			let t = e.closest(B);
			t ? t.appendChild(e.parentElement === t ? e : e.closest(`${B} > *`)) : r.appendChild(e.parentElement === r ? e : e.closest(`${B} > *`));
		}), t.sort((e, t) => t[1] - e[1]).forEach((e) => {
			let t = S.current?.querySelector(`${z}[${U}="${encodeURIComponent(e[0])}"]`);
			t?.parentElement.appendChild(t);
		});
	}
	function O() {
		let e = M().find((e) => e.getAttribute("aria-disabled") !== "true")?.getAttribute(U);
		w.setState("value", e || void 0);
	}
	function k() {
		if (!n.current.search || c.current.shouldFilter === !1) {
			n.current.filtered.count = i.current.size;
			return;
		}
		n.current.filtered.groups = /* @__PURE__ */ new Set();
		let e = 0;
		for (let t of i.current) {
			let r = E(o.current.get(t)?.value ?? "", o.current.get(t)?.keywords ?? []);
			n.current.filtered.items.set(t, r), r > 0 && e++;
		}
		for (let [e, t] of a.current) for (let r of t) if (n.current.filtered.items.get(r) > 0) {
			n.current.filtered.groups.add(e);
			break;
		}
		n.current.filtered.count = e;
	}
	function A() {
		var e;
		let t = j();
		t && (t.parentElement?.firstChild === t && ((e = t.closest(z)?.querySelector(te)) == null || e.scrollIntoView({ block: "nearest" })), t.scrollIntoView({ block: "nearest" }));
	}
	function j() {
		return S.current?.querySelector(`${ne}[aria-selected="true"]`);
	}
	function M() {
		return Array.from(S.current?.querySelectorAll(V) || []);
	}
	function N(e) {
		let t = M()[e];
		t && w.setState("value", t.getAttribute(U));
	}
	function P(e) {
		var t;
		let n = j(), r = M(), i = r.findIndex((e) => e === n), a = r[i + e];
		(t = c.current) != null && t.loop && (a = i + e < 0 ? r[r.length - 1] : i + e === r.length ? r[0] : r[i + e]), a && w.setState("value", a.getAttribute(U));
	}
	function F(e) {
		let t = j()?.closest(z), n;
		for (; t && !n;) t = e > 0 ? me(t, z) : he(t, z), n = t?.querySelector(V);
		n ? w.setState("value", n.getAttribute(U)) : P(e);
	}
	let I = () => N(M().length - 1), L = (e) => {
		e.preventDefault(), e.metaKey ? I() : e.altKey ? F(1) : P(1);
	}, W = (e) => {
		e.preventDefault(), e.metaKey ? N(0) : e.altKey ? F(-1) : P(-1);
	};
	return l.createElement(R.div, {
		ref: t,
		tabIndex: -1,
		...y,
		"cmdk-root": "",
		onKeyDown: (e) => {
			var t;
			(t = y.onKeyDown) == null || t.call(y, e);
			let n = e.nativeEvent.isComposing || e.keyCode === 229;
			if (!(e.defaultPrevented || n)) switch (e.key) {
				case "n":
				case "j":
					v && e.ctrlKey && L(e);
					break;
				case "ArrowDown":
					L(e);
					break;
				case "p":
				case "k":
					v && e.ctrlKey && W(e);
					break;
				case "ArrowUp":
					W(e);
					break;
				case "Home":
					e.preventDefault(), N(0);
					break;
				case "End":
					e.preventDefault(), I();
					break;
				case "Enter": {
					e.preventDefault();
					let t = j();
					if (t) {
						let e = new Event(H);
						t.dispatchEvent(e);
					}
				}
			}
		}
	}, l.createElement("label", {
		"cmdk-label": "",
		htmlFor: T.inputId,
		id: T.labelId,
		style: be
	}, u), Q(e, (e) => l.createElement(ae.Provider, { value: w }, l.createElement(ie.Provider, { value: T }, e))));
}), oe = l.forwardRef((e, t) => {
	let i = r(), a = l.useRef(null), o = l.useContext(K), s = W(), c = ge(e), u = c.current?.forceMount ?? o?.forceMount;
	Y(() => {
		if (!u) return s.item(i, o?.id);
	}, [u]);
	let d = _e(i, a, [
		e.value,
		e.children,
		a
	], e.keywords), f = G(), p = Z((e) => e.value && e.value === d.current), m = Z((e) => u || s.filter() === !1 ? !0 : !e.search || e.filtered.items.get(i) > 0);
	l.useEffect(() => {
		let t = a.current;
		if (!(!t || e.disabled)) return t.addEventListener(H, h), () => t.removeEventListener(H, h);
	}, [
		m,
		e.onSelect,
		e.disabled
	]);
	function h() {
		var e, t;
		g(), (t = (e = c.current).onSelect) == null || t.call(e, d.current);
	}
	function g() {
		f.setState("value", d.current, !0);
	}
	if (!m) return null;
	let { disabled: _, value: v, onSelect: y, forceMount: b, keywords: ee, ...x } = e;
	return l.createElement(R.div, {
		ref: n(a, t),
		...x,
		id: i,
		"cmdk-item": "",
		role: "option",
		"aria-disabled": !!_,
		"aria-selected": !!p,
		"data-disabled": !!_,
		"data-selected": !!p,
		onPointerMove: _ || s.getDisablePointerSelection() ? void 0 : g,
		onClick: _ ? void 0 : h
	}, e.children);
}), se = l.forwardRef((e, t) => {
	let { heading: i, children: a, forceMount: o, ...s } = e, c = r(), u = l.useRef(null), d = l.useRef(null), f = r(), p = W(), m = Z((e) => o || p.filter() === !1 ? !0 : !e.search || e.filtered.groups.has(c));
	Y(() => p.group(c), []), _e(c, u, [
		e.value,
		e.heading,
		d
	]);
	let h = l.useMemo(() => ({
		id: c,
		forceMount: o
	}), [o]);
	return l.createElement(R.div, {
		ref: n(u, t),
		...s,
		"cmdk-group": "",
		role: "presentation",
		hidden: !m || void 0
	}, i && l.createElement("div", {
		ref: d,
		"cmdk-group-heading": "",
		"aria-hidden": !0,
		id: f
	}, i), Q(e, (e) => l.createElement("div", {
		"cmdk-group-items": "",
		role: "group",
		"aria-labelledby": i ? f : void 0
	}, l.createElement(K.Provider, { value: h }, e))));
}), ce = l.forwardRef((e, t) => {
	let { alwaysRender: r, ...i } = e, a = l.useRef(null), o = Z((e) => !e.search);
	return !r && !o ? null : l.createElement(R.div, {
		ref: n(a, t),
		...i,
		"cmdk-separator": "",
		role: "separator"
	});
}), le = l.forwardRef((e, t) => {
	let { onValueChange: n, ...r } = e, i = e.value != null, a = G(), o = Z((e) => e.search), s = Z((e) => e.selectedItemId), c = W();
	return l.useEffect(() => {
		e.value != null && a.setState("search", e.value);
	}, [e.value]), l.createElement(R.input, {
		ref: t,
		...r,
		"cmdk-input": "",
		autoComplete: "off",
		autoCorrect: "off",
		spellCheck: !1,
		"aria-autocomplete": "list",
		role: "combobox",
		"aria-expanded": !0,
		"aria-controls": c.listId,
		"aria-labelledby": c.labelId,
		"aria-activedescendant": s,
		id: c.inputId,
		type: "text",
		value: i ? e.value : o,
		onChange: (e) => {
			i || a.setState("search", e.target.value), n?.(e.target.value);
		}
	});
}), ue = l.forwardRef((e, t) => {
	let { children: r, label: i = "Suggestions", ...a } = e, o = l.useRef(null), s = l.useRef(null), c = Z((e) => e.selectedItemId), u = W();
	return l.useEffect(() => {
		if (s.current && o.current) {
			let e = s.current, t = o.current, n, r = new ResizeObserver(() => {
				n = requestAnimationFrame(() => {
					let n = e.offsetHeight;
					t.style.setProperty("--cmdk-list-height", n.toFixed(1) + "px");
				});
			});
			return r.observe(e), () => {
				cancelAnimationFrame(n), r.unobserve(e);
			};
		}
	}, []), l.createElement(R.div, {
		ref: n(o, t),
		...a,
		"cmdk-list": "",
		role: "listbox",
		tabIndex: -1,
		"aria-activedescendant": c,
		"aria-label": i,
		id: u.listId
	}, Q(e, (e) => l.createElement("div", {
		ref: n(s, u.listInnerRef),
		"cmdk-list-sizer": ""
	}, e)));
}), de = l.forwardRef((e, t) => {
	let { open: n, onOpenChange: r, overlayClassName: c, contentClassName: u, container: d, ...f } = e;
	return l.createElement(s, {
		open: n,
		onOpenChange: r
	}, l.createElement(a, { container: d }, l.createElement(i, {
		"cmdk-overlay": "",
		className: c
	}), l.createElement(o, {
		"aria-label": e.label,
		"cmdk-dialog": "",
		className: u
	}, l.createElement(q, {
		ref: t,
		...f
	}))));
}), fe = l.forwardRef((e, t) => Z((e) => e.filtered.count === 0) ? l.createElement(R.div, {
	ref: t,
	...e,
	"cmdk-empty": "",
	role: "presentation"
}) : null), pe = l.forwardRef((e, t) => {
	let { progress: n, children: r, label: i = "Loading...", ...a } = e;
	return l.createElement(R.div, {
		ref: t,
		...a,
		"cmdk-loading": "",
		role: "progressbar",
		"aria-valuenow": n,
		"aria-valuemin": 0,
		"aria-valuemax": 100,
		"aria-label": i
	}, Q(e, (e) => l.createElement("div", { "aria-hidden": !0 }, e)));
}), J = Object.assign(q, {
	List: ue,
	Item: oe,
	Input: le,
	Group: se,
	Separator: ce,
	Dialog: de,
	Empty: fe,
	Loading: pe
});
function me(e, t) {
	let n = e.nextElementSibling;
	for (; n;) {
		if (n.matches(t)) return n;
		n = n.nextElementSibling;
	}
}
function he(e, t) {
	let n = e.previousElementSibling;
	for (; n;) {
		if (n.matches(t)) return n;
		n = n.previousElementSibling;
	}
}
function ge(e) {
	let t = l.useRef(e);
	return Y(() => {
		t.current = e;
	}), t;
}
var Y = typeof window > "u" ? l.useEffect : l.useLayoutEffect;
function X(e) {
	let t = l.useRef();
	return t.current === void 0 && (t.current = e()), t;
}
function Z(e) {
	let t = G(), n = () => e(t.snapshot());
	return l.useSyncExternalStore(t.subscribe, n, n);
}
function _e(e, t, n, r = []) {
	let i = l.useRef(), a = W();
	return Y(() => {
		var o;
		let s = (() => {
			for (let e of n) {
				if (typeof e == "string") return e.trim();
				if (typeof e == "object" && "current" in e) return e.current ? e.current.textContent?.trim() : i.current;
			}
		})(), c = r.map((e) => e.trim());
		a.value(e, s, c), (o = t.current) == null || o.setAttribute(U, s), i.current = s;
	}), i;
}
var ve = () => {
	let [e, t] = l.useState(), n = X(() => /* @__PURE__ */ new Map());
	return Y(() => {
		n.current.forEach((e) => e()), n.current = /* @__PURE__ */ new Map();
	}, [e]), (e, r) => {
		n.current.set(e, r), t({});
	};
};
function ye(e) {
	let t = e.type;
	return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Q({ asChild: e, children: t }, n) {
	return e && l.isValidElement(t) ? l.cloneElement(ye(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var be = {
	position: "absolute",
	width: "1px",
	height: "1px",
	padding: "0",
	margin: "-1px",
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	borderWidth: "0"
}, $ = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(J, {
	ref: r,
	className: e("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", t),
	...n
}));
$.displayName = J.displayName;
var xe = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ d("div", {
	className: "flex items-center border-b px-3",
	"cmdk-input-wrapper": "",
	children: [/* @__PURE__ */ u(c, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }), /* @__PURE__ */ u(J.Input, {
		ref: r,
		className: e("flex h-11 w-full rounded-md bg-transparent py-3 text-base outline-none md:text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", t),
		...n
	})]
}));
xe.displayName = J.Input.displayName;
var Se = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(J.List, {
	ref: r,
	className: e("max-h-[300px] overflow-y-auto overflow-x-hidden", t),
	...n
}));
Se.displayName = J.List.displayName;
var Ce = l.forwardRef((e, t) => /* @__PURE__ */ u(J.Empty, {
	ref: t,
	className: "py-6 text-center text-sm",
	...e
}));
Ce.displayName = J.Empty.displayName;
var we = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(J.Group, {
	ref: r,
	className: e("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", t),
	...n
}));
we.displayName = J.Group.displayName;
var Te = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(J.Separator, {
	ref: r,
	className: e("-mx-1 h-px bg-border", t),
	...n
}));
Te.displayName = J.Separator.displayName;
var Ee = l.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ u(J.Item, {
	ref: r,
	className: e("relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t),
	...n
}));
Ee.displayName = J.Item.displayName;
var De = ({ className: t, ...n }) => /* @__PURE__ */ u("span", {
	className: e("ml-auto text-xs tracking-widest text-muted-foreground", t),
	...n
});
De.displayName = "CommandShortcut";
//#endregion
export { Ee as a, De as c, xe as i, Ce as n, Se as o, we as r, Te as s, $ as t };

//# sourceMappingURL=command-Bd6gcY9v.js.map